import { api } from "./services/requests";

async function initApp() {
  try {
    const response = await api.isActive()
    if (response.data.active) {
        console.log("Experiência ativa. Redirecionando para a página principal...");
        window.location.href = './index.html';
        return;
    }
  }catch(error) {
    console.error("Erro ao verificar o status da experiência:", error);
  };

}

window.addEventListener("DOMContentLoaded", initApp);